import React, { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { LoadingScreen } from "@/components/common/LoadingScreen";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";

const HomePage = lazy(() => import("@/pages/home/HomePage"));
const JobsPage = lazy(() => import("@/pages/jobs/JobsPage"));
const JobDetailPage = lazy(() => import("@/pages/job-detail/JobDetailPage"));
const KycPage = lazy(() => import("@/pages/kyc/KycPage"));
const NotFoundPage = lazy(() => import("@/pages/errors/NotFoundPage"));

function AppRoutes() {
  const location = useLocation();

  return (
    <Suspense key={location.pathname} fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<HomePage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="jobs/:id" element={<JobDetailPage />} />
          <Route path="kyc" element={<KycPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
